@if (partnerVarenrMapping.id) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger varenummer</h1>
}
@if (!partnerVarenrMapping.id) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Opret varenummer</h1>
}
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Partner</mat-label>
        <input formControlName="partnerVarenr" matInput />
      </mat-form-field>
    </div>

    <div class="form-row no-margin-bottom">
      <mat-form-field appearance="outline">
        <mat-label>OK</mat-label>
        <input formControlName="okKundeVarenr" matInput />
        @if (vareInfoCollected) {
          <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearVareInfo()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <mat-hint [matTooltip]="!vareInfoCollected ? 'Udfyld varenr. felt for at hente vareinfo' : ''">
          <button
            class="btn-icon"
            [class.blue]="!vareInfoCollected"
            [class.green]="vareInfoCollected"
            [disabled]="!okKundeVarenr.value"
            (click)="getInfoForVareNr(okKundeVarenr.value)"
          >
            @if (!vareInfoCollected) {
              <mat-icon svgIcon="download"></mat-icon>
            }
            @if (vareInfoCollected) {
              <mat-icon svgIcon="checkmark"></mat-icon>
            }
            @if (!vareInfoCollected) {
              <span>Hent vareinfo fra G4</span>
            }
            @if (vareInfoCollected) {
              <span>Vareinfo hentet fra G4</span>
            }
          </button>
        </mat-hint>
        @if (noVareInfoInG4) {
          <div class="red tiny-text">Varen findes ikke i G4 - eller har ingen pris i G4.</div>
        }
      </mat-form-field>
    </div>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close="">Fortryd</button>
  <button [disabled]="!form.valid || !vareInfoCollected" mat-raised-button color="primary" (click)="do()">Gem</button>
</div>
